export default __webpack_public_path__ + "static/media/dating3.603f48c0.png";